import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/faq/page.tsx")